export function GetRegionFromLocation(location: string): string {
  const normalizedLocation = (location || '').toLowerCase()

  const regionMap: { [key: string]: string } = {
    "philippines": "ASIA",
    "japan": "ASIA",
    "south korea": "ASIA",
    "thailand": "ASIA",
    "singapore": "ASIA",
    "malaysia": "ASIA",
    "indonesia": "ASIA",
    "vietnam": "ASIA",
    "taiwan": "ASIA",
    "china": "ASIA",
    "india": "ASIA",
    "vatican city": "EUROPE",
    "austria": "EUROPE",
    "liechtenstein": "EUROPE",
    "switzerland": "EUROPE",
    "france": "EUROPE",
    "luxembourg": "EUROPE",
    "belgium": "EUROPE",
    "netherlands": "EUROPE",
    "spain": "EUROPE",
    "greece": "EUROPE",
    "turkey": "EUROPE",
    "italy": "EUROPE",
    "usa": "AMERICA",
    "united states": "AMERICA",
    "united states of america": "AMERICA",
    "canada": "AMERICA",
    "mexico": "AMERICA",
    "brazil": "AMERICA",
    "argentina": "AMERICA",
    "colombia": "AMERICA",
    "chile": "AMERICA",
    "peru": "AMERICA",
    "egypt": "AFRICA",
    "morocco": "AFRICA",
    "south africa": "AFRICA",
    "kenya": "AFRICA",
    "tanzania": "AFRICA",
    "zambia": "AFRICA",
    "tunisia": "AFRICA",
  }

  for (const [country, region] of Object.entries(regionMap)) {
    if (normalizedLocation.includes(country)) {
      return region
    }
  }

  return "ASIA"
}
